import React from "react";
import { MobileSheet } from "./MobileSheet";
import { ProviderOption, ProviderOptionList } from "./ProviderOptionList";

export interface MobileWeekProviderSheetProps {
  opened: boolean;
  onClose: () => void;
  /** Providers the week view can show (the filtered staff). */
  options: ProviderOption[];
  selectedId: string | null;
  /** Show this provider's week (the sheet closes). */
  onPick: (id: string) => void;
}

/** Bottom sheet that picks whose schedule the week view shows. */
export const MobileWeekProviderSheet: React.FC<
  MobileWeekProviderSheetProps
> = ({ opened, onClose, options, selectedId, onPick }) => (
  <MobileSheet
    opened={opened}
    onClose={onClose}
    title="Select provider"
    subtitle="Week view shows one provider's schedule"
    data-testid="mobile-week-provider-sheet"
  >
    <ProviderOptionList
      options={options}
      selectedId={selectedId}
      onPick={(id) => {
        onPick(id);
        onClose();
      }}
    />
  </MobileSheet>
);
